(function () {
  'use strict';

  /**
   * Element.closest() from an event target that may not be an Element.
   * event.target is `document` for a document-level mouseenter and can be a
   * text node elsewhere; calling .closest() on those throws a TypeError that
   * aborts the handler. Delegates to MMCompat when the compat layer is loaded.
   */
  function targetClosest(e, selector) {
    if (window.MMCompat && window.MMCompat.closestFrom) {
      return window.MMCompat.closestFrom(e && e.target, selector);
    }
    var node = e && e.target;
    while (node && node.nodeType !== 1) node = node.parentElement || node.parentNode || null;
    return node && typeof node.closest === 'function' ? node.closest(selector) : null;
  }

  function localeCode(ctx) {
    if (ctx && ctx.getAttribute) {
      var dl = ctx.getAttribute('data-lang');
      if (dl) return dl;
    }
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    return document.documentElement.lang || 'en';
  }

  function isAr(ctx) {
    if (ctx && ctx.getAttribute) {
      var dl = ctx.getAttribute('data-lang');
      if (dl) return dl.toLowerCase().indexOf('ar') === 0;
    }
    if (document.documentElement.getAttribute('dir') === 'rtl') return true;
    if (window.Shopify && window.Shopify.locale) {
      return window.Shopify.locale.toLowerCase().indexOf('ar') === 0;
    }
    return (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  }

  function t(en, ar, ctx) {
    return isAr(ctx) ? (ar || en) : (en || ar);
  }

  function moneyDiv(ctx) {
    if (ctx && ctx.getAttribute) {
      var d = parseInt(ctx.getAttribute('data-money-divisor'), 10);
      if (d === 100 || d === 1000) return d;
    }
    var htmlDiv = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
    if (htmlDiv === 100 || htmlDiv === 1000) return htmlDiv;
    return 100;
  }

  function marketCountry() {
    var host = document.body || document.documentElement;
    var html = document.documentElement;
    var currency = '';
    if (html && html.getAttribute) currency = html.getAttribute('data-mm-currency') || '';
    try {
      currency = currency || localStorage.getItem('mm_display_currency_user') || '';
    } catch (e) {}
    if (String(currency).toUpperCase() === 'SAR') return 'SA';

    var country = '';
    if (host && host.getAttribute) country = host.getAttribute('data-mm-country') || '';
    if (!country && html && html.getAttribute) country = html.getAttribute('data-mm-country') || '';
    return String(country || 'BH').trim().toUpperCase() || 'BH';
  }

  function offersApiUrl(params) {
    params = params || {};
    var query = ['country=' + encodeURIComponent(marketCountry())];
    if (params.productHandle) query.push('productHandle=' + encodeURIComponent(params.productHandle));
    if (params.slug) query.push('slug=' + encodeURIComponent(params.slug));
    return '/apps/mm-app/api/offers?' + query.join('&');
  }

  function fmtPrice(minor, ctx) {
    minor = parseInt(minor, 10) || 0;
    var div = moneyDiv(ctx);
    if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.formatWithTax === 'function') {
      return window.mmCurrencyConfig.formatWithTax(minor, div);
    }
    if (window.mmTaxConfig && typeof window.mmTaxConfig.formatWithTax === 'function') {
      return window.mmTaxConfig.formatWithTax(minor);
    }
    var taxed = minor;
    if (window.mmTaxConfig && typeof window.mmTaxConfig.applyTax === 'function') {
      taxed = Math.round(window.mmTaxConfig.applyTax(minor));
    }
    var amt = (taxed / div).toFixed(3);
    if (isAr(ctx)) return amt + ' د.ب';
    return 'BHD ' + amt;
  }

  function priceSpan(minor, ctx) {
    minor = parseInt(minor, 10) || 0;
    return '<span class="mm-taxed-price" data-original-price="' + minor + '" data-mm-divisor="' + moneyDiv(ctx) + '">' +
      fmtPrice(minor, ctx) + '</span>';
  }

  function jp(raw, fallback) {
    if (raw == null) return fallback != null ? fallback : [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'object') return raw;
    try { return JSON.parse(raw || '[]'); } catch (e) { return fallback != null ? fallback : []; }
  }

  /** Bundle config is an array; BOGO config is { trigger, target }. */
  function configItems(raw) {
    var v = jp(raw, []);
    if (Array.isArray(v)) return v;
    if (v && typeof v === 'object') {
      var out = [];
      if (v.trigger) out.push(v.trigger);
      if (v.target) out.push(v.target);
      return out;
    }
    return [];
  }

  function offerTitle(offer, prod, ctx) {
    if (isAr(ctx)) {
      var ar = String(offer.titleAr || '').trim();
      if (ar) return ar;
      var manual = offer._manual || {};
      if (manual.titleAr) return manual.titleAr;
      var items = configItems(offer.bundleItemsConfig);
      for (var i = 0; i < items.length; i++) {
        if (items[i] && items[i].titleAr) return items[i].titleAr;
      }
    }
    if (offer.title) return offer.title;
    if (offer.name) return offer.name;
    var manualEn = offer._manual || {};
    if (manualEn.title) return manualEn.title;
    if (prod && prod.title) return prod.title;
    return '';
  }

  /** Singular/plural unit labels for volume tiers (Box, Piece, etc.) from variant size option. */
  function volumeUnitLabels(product, variant, ar) {
    var fallback = ar
      ? { one: 'قطعة', many: 'قطع' }
      : { one: 'piece', many: 'pieces' };
    if (!product) return fallback;

    var optNames = product.options || [];
    var sizeIdx = -1;
    for (var i = 0; i < optNames.length; i++) {
      var rawName = optNames[i];
      var name = String(typeof rawName === 'string' ? rawName : (rawName && rawName.name) || '').toLowerCase();
      if (/size|حجم|weight|وزن|pack|quantity|كمية/i.test(name)) {
        sizeIdx = i;
        break;
      }
    }

    var v = variant || (product.variants && product.variants[0]);
    if (sizeIdx >= 0 && v) {
      var val = String(v['option' + (sizeIdx + 1)] || '').trim();
      if (val) return { one: val, many: val };
    }

    if (v && v.title && v.title !== 'Default Title') {
      var parts = String(v.title).split(/\s*\/\s*|\s*-\s*/);
      var last = parts[parts.length - 1].trim();
      if (last && /box|بوكس|pack|piece|قطعة|حبة/i.test(last)) {
        return { one: last, many: last };
      }
    }

    return fallback;
  }

  function volumeQtyLabel(qty, units) {
    qty = parseInt(qty, 10) || 1;
    if (qty === 1) return '1 ' + units.one;
    return qty + ' ' + units.many;
  }

  function bogoLabel(offer, ctx) {
    var ds = jp(offer.displaySettings, {});
    var buyQ = parseInt(ds.bogoQtyBuy, 10) || 1;
    var getQ = parseInt(ds.bogoQtyGet, 10) || 1;
    return t('Buy ' + buyQ + ' Get ' + getQ, 'اشتري ' + buyQ + ' واحصل على ' + getQ + ' مجاناً', ctx);
  }

  function typeLabel(type, ctx) {
    if (type === 'BOGO') return t('Buy 1 Get 1', 'اشتري 1 والثاني مجاناً', ctx);
    if (type === 'BUNDLE') return t('Bundle deal', 'عرض باقة', ctx);
    if (type === 'VOLUME') return t('Volume discount', 'خصم الكمية', ctx);
    if (type === 'DISCOUNTED_PRODUCT') return t('Special price', 'سعر خاص', ctx);
    return t('Offer', 'عرض', ctx);
  }

  function stockLabel(qty, settings, ctx) {
    if (!qty || qty <= 0) return '';
    var tpl = isAr(ctx)
      ? ((settings && settings.onlyLeftAr) || 'متبقي {quantity} فقط')
      : ((settings && settings.onlyLeftEn) || 'Only {quantity} left');
    return tpl.replace('{quantity}', String(qty));
  }

  function startTimer(endsAt, el, ctx) {
    if (!endsAt || !el) return;
    var endMs = new Date(endsAt).getTime();
    if (isNaN(endMs)) return;
    ctx = ctx || el.closest('[data-lang]') || el;

    function tick() {
      var left = endMs - Date.now();
      if (left <= 0) {
        el.textContent = isAr(ctx) ? 'انتهى' : 'Ended';
        return;
      }
      var d = Math.floor(left / 86400000);
      var h = Math.floor((left % 86400000) / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      if (d > 0) {
        el.textContent = (isAr(ctx) ? d + 'ي ' : d + 'd ') + pad(h) + ':' + pad(m);
      } else {
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      setTimeout(tick, 1000);
    }
    tick();
  }

  function gidId(id) {
    if (id == null) return '';
    var s = String(id);
    return s.indexOf('gid://') >= 0 ? s.split('/').pop() : s;
  }

  function configMajorToMinor(val, div) {
    var n = parseFloat(val);
    if (!n || isNaN(n)) return 0;
    return Math.round(n * div);
  }

  function variantFromConfig(item, div) {
    if (!item || !item.variants || !item.variants.length) return null;
    var ids = [];
    if (item.selectedVariantId) ids.push(gidId(item.selectedVariantId));
    (item.selectedVariantIds || []).forEach(function (id) { ids.push(gidId(id)); });
    for (var i = 0; i < item.variants.length; i++) {
      var cv = item.variants[i];
      if (ids.length && ids.indexOf(gidId(cv.id)) < 0) continue;
      var price = configMajorToMinor(cv.price, div);
      return { id: gidId(cv.id), price: price, compare_at_price: price, title: cv.title };
    }
    var first = item.variants[0];
    return {
      id: gidId(first.id),
      price: configMajorToMinor(first.price, div),
      compare_at_price: configMajorToMinor(first.price, div),
      title: first.title
    };
  }

  function resolveItemVariant(prod, item, div) {
    if (prod && prod.variants && prod.variants.length) {
      var ids = [];
      if (item.selectedVariantId) ids.push(gidId(item.selectedVariantId));
      (item.selectedVariantIds || []).forEach(function (id) { ids.push(gidId(id)); });
      if (ids.length) {
        for (var j = 0; j < ids.length; j++) {
          for (var i = 0; i < prod.variants.length; i++) {
            if (String(prod.variants[i].id) === String(ids[j])) return prod.variants[i];
          }
        }
      }
      return prod.variants[0];
    }
    return variantFromConfig(item, div);
  }

  function lineVariantsForItem(prod, item, div) {
    if (item && item.isFixedSelection && item.selectedVariantIds && item.selectedVariantIds.length > 1) {
      var out = [];
      item.selectedVariantIds.forEach(function (sid) {
        var id = gidId(sid);
        var found = null;
        if (prod && prod.variants) {
          for (var i = 0; i < prod.variants.length; i++) {
            if (String(prod.variants[i].id) === String(id)) { found = prod.variants[i]; break; }
          }
        }
        if (!found && item.variants) {
          for (var j = 0; j < item.variants.length; j++) {
            if (gidId(item.variants[j].id) === id) {
              var p = configMajorToMinor(item.variants[j].price, div);
              found = { price: p, compare_at_price: p };
              break;
            }
          }
        }
        if (found) out.push(found);
      });
      return out;
    }
    var v = resolveItemVariant(prod, item, div);
    return v ? [v] : [];
  }

  function volumeMaxPct(offer) {
    var tiers = jp(offer.volumeTiers);
    var best = 0;
    tiers.forEach(function (tier) {
      var d = parseFloat(tier.discount) || 0;
      if (d > best) best = d;
    });
    return Math.round(best);
  }

  function estimateBundlePrices(offer, products, ctx) {
    var div = moneyDiv(ctx);
    var items = configItems(offer.bundleItemsConfig);
    var flatProds = [];
    (products || []).forEach(function (p) {
      if (Array.isArray(p)) flatProds.push(p.filter(Boolean)[0] || null);
      else flatProds.push(p || null);
    });
    var orig = 0;
    var disc = 0;
    var saleSum = 0;
    items.forEach(function (item, i) {
      if (!item) return;
      var prod = flatProds[i];
      var qty = Math.max(1, parseInt(item.quantity || item.qty || item.requiredQuantity, 10) || 1);
      var vars = lineVariantsForItem(prod, item, div);
      if (!vars.length) return;
      vars.forEach(function (v) {
        var linePrice = v.price || 0;
        var lineCompare = (v.compare_at_price && v.compare_at_price > linePrice) ? v.compare_at_price : linePrice;
        orig += lineCompare * qty;
        saleSum += linePrice * qty;
        var pDisc = parseFloat((item.discount || 0)) / 100;
        if (offer.discountMode === 'PER_PRODUCT' && pDisc > 0) {
          disc += Math.round(linePrice * (1 - pDisc)) * qty;
        } else {
          disc += linePrice * qty;
        }
      });
    });
    if (offer.discountMode !== 'PER_PRODUCT') {
      var dv = parseFloat(offer.discountValue) || 0;
      if (offer.discountType === 'PERCENTAGE') disc = Math.round(saleSum * (1 - dv / 100));
      else if (offer.discountType === 'FIXED_EACH') {
        var cnt = 0;
        items.forEach(function (it) {
          if (!it) return;
          cnt += Math.max(1, parseInt(it.quantity || it.qty || 1, 10) || 1);
        });
        if (!cnt) cnt = items.length || 1;
        disc = Math.max(0, saleSum - Math.round(dv * div) * cnt);
      } else disc = Math.max(0, saleSum - Math.round(dv * div));
    }
    if (saleSum > 0 && orig <= saleSum) orig = saleSum;
    if (orig <= disc && saleSum > disc) orig = saleSum;
    return { price: disc, compare: orig > disc ? orig : (saleSum > disc ? saleSum : 0) };
  }

  function estimateBogoPrices(offer, products, ctx) {
    var div = ctx ? moneyDiv(ctx) : 1000;
    var items = configItems(offer.bundleItemsConfig);
    var flatProds = [];
    (products || []).forEach(function (p) {
      if (Array.isArray(p)) flatProds.push(p.filter(Boolean)[0] || null);
      else flatProds.push(p || null);
    });
    var triggerItem = items[0] || {};
    var targetItem = items[1] || items[0] || {};
    var trigger = flatProds[0];
    var target = flatProds[1] || flatProds[0];
    var buyV = resolveItemVariant(trigger, triggerItem, div);
    var getV = resolveItemVariant(target, targetItem, div) || buyV;
    var buyP = buyV ? buyV.price : 0;
    var getP = getV ? getV.price : buyP;
    var ds = jp(offer.displaySettings, {});
    var buyQ = parseInt(ds.bogoQtyBuy, 10) || 1;
    var getQ = parseInt(ds.bogoQtyGet, 10) || 1;
    var compare = buyP * buyQ + getP * getQ;
    var price = buyP * buyQ;
    return { price: price, compare: compare > price ? compare : 0 };
  }

  function estimateVolumePrices(offer, prod, ctx) {
    var div = moneyDiv(ctx);
    var items = configItems(offer.bundleItemsConfig);
    var item = items[0] || {};
    var v = prod ? resolveItemVariant(prod, item, div) : variantFromConfig(item, div);
    var base = v ? v.price : (prod ? prod.price : 0);
    var compare = v && v.compare_at_price > base ? v.compare_at_price : base;
    return { price: base, compare: compare, maxPct: volumeMaxPct(offer) };
  }

  function offerPrices(offer, prod, ctx) {
    if (offer.type === 'DISCOUNTED_PRODUCT') {
      var manual = offer._manual || {};
      var div = moneyDiv(ctx);
      var price = manual.manualPrice ? Math.round(parseFloat(manual.manualPrice) * div) : (prod ? prod.price : 0);
      var compare = manual.manualComparePrice ? Math.round(parseFloat(manual.manualComparePrice) * div) : (prod ? prod.compare_at_price : 0);
      return { price: price, compare: compare };
    }
    if (offer.type === 'VOLUME') {
      return estimateVolumePrices(offer, prod, ctx);
    }
    if (offer.type === 'BUNDLE' && offer._bundleProducts) {
      return estimateBundlePrices(offer, offer._bundleProducts, ctx);
    }
    if (offer.type === 'BOGO' && offer._bundleProducts) {
      return estimateBogoPrices(offer, offer._bundleProducts, ctx);
    }
    if (offer.type === 'BOGO' && prod) {
      return estimateBogoPrices(offer, [prod, prod], ctx);
    }
    if (prod) {
      return { price: prod.price || 0, compare: prod.compare_at_price || 0 };
    }
    return { price: 0, compare: 0 };
  }

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root.slice(0, -1) : root;
  }

  function firstOfferHandle(offer) {
    if (!offer) return '';
    var triggers = jp(offer.triggerProducts);
    if (triggers[0]) return triggers[0];
    var items = configItems(offer.bundleItemsConfig);
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].handle) return items[i].handle;
      if (items[i] && items[i].type === 'choice_group') {
        var opts = items[i].options || [];
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] && opts[j].handle) return opts[j].handle;
        }
      }
    }
    if (offer._prod && offer._prod.handle) return offer._prod.handle;
    return '';
  }

  function variantIdFromOffer(offer) {
    var manual = offer._manual || {};
    if (manual.selectedVariantId) return gidId(manual.selectedVariantId);
    var items = configItems(offer.bundleItemsConfig);
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].selectedVariantId) return gidId(items[i].selectedVariantId);
    }
    return '';
  }

  function variantLabelFromOffer(offer, ctx) {
    var manual = offer._manual || {};
    if (isAr(ctx) && manual.variantTitleAr) return manual.variantTitleAr;
    if (manual.variantTitle) return manual.variantTitle;
    var items = configItems(offer.bundleItemsConfig);
    var item = items[0] || {};
    if (isAr(ctx) && item.variantTitleAr) return item.variantTitleAr;
    return item.variantTitle || '';
  }

  function manualImageFromOffer(offer) {
    if (!isCompareAtDeal(offer)) return '';
    var manual = offer._manual || {};
    if (manual.image) return manual.image;
    var items = configItems(offer.bundleItemsConfig);
    return (items[0] && items[0].image) || '';
  }

  function isCompareAtDeal(offer) {
    if (!offer) return false;
    if (offer._isGlobal) return true;
    return offer.type === 'DISCOUNTED_PRODUCT' && String(offer.id || '').indexOf('global-') === 0;
  }

  function isPerVariantCompareAtDeal(offer) {
    if (!isCompareAtDeal(offer)) return false;
    var id = String(offer.id || '');
    if (/^global-\d+-\d+$/.test(id)) return true;
    ensureCompareAtManual(offer);
    var manual = offer._manual || {};
    if (manual.selectedVariantId) {
      var vt = String(manual.variantTitle || '');
      if (!vt || vt.indexOf('variants') === -1) return true;
    }
    return false;
  }

  function ensureCompareAtManual(offer) {
    if (!offer) return offer;
    if (!offer._manual) {
      var items = configItems(offer.bundleItemsConfig);
      if (items[0]) offer._manual = items[0];
    }
    if (isCompareAtDeal(offer)) offer._isGlobal = true;
    return offer;
  }

  function minorToMajor(minor, div) {
    minor = parseInt(minor, 10) || 0;
    div = div || moneyDiv();
    return (minor / div).toFixed(3);
  }

  function buildCompareAtOfferFromVariant(base, prod, variant, div) {
    div = div || moneyDiv();
    var vid = String(variant.id);
    var pid = String(prod.id);
    var img = variantImageFromProduct(prod, vid);
    var vTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    var manual = {
      handle: prod.handle,
      title: prod.title,
      titleAr: base.titleAr || prod.title,
      selectedVariantId: vid,
      variantTitle: vTitle,
      manualPrice: minorToMajor(variant.price, div),
      manualComparePrice: minorToMajor(variant.compare_at_price, div),
      image: img
    };
    return ensureCompareAtManual({
      id: 'global-' + pid + '-' + vid,
      type: 'DISCOUNTED_PRODUCT',
      title: prod.title,
      titleAr: base.titleAr || prod.title,
      images: img ? JSON.stringify([img]) : base.images,
      triggerProducts: JSON.stringify([prod.handle]),
      bundleItemsConfig: JSON.stringify([manual]),
      endsAt: base.endsAt,
      customerQuantity: base.customerQuantity,
      _isGlobal: true,
      _manual: manual
    });
  }

  async function expandCompareAtOffers(offers, fetchProductFn) {
    if (!offers || !offers.length) return [];
    var out = [];

    for (var i = 0; i < offers.length; i++) {
      var o = offers[i];
      if (!isCompareAtDeal(o)) {
        out.push(o);
        continue;
      }

      if (isPerVariantCompareAtDeal(o)) {
        out.push(ensureCompareAtManual(o));
        continue;
      }

      var handle = firstOfferHandle(o);
      if (!handle || typeof fetchProductFn !== 'function') {
        out.push(ensureCompareAtManual(o));
        continue;
      }

      var prod = await fetchProductFn(handle);
      if (!prod || !prod.variants || !prod.variants.length) {
        out.push(ensureCompareAtManual(o));
        continue;
      }

      var saleVars = prod.variants.filter(function (v) {
        var cp = parseInt(v.compare_at_price, 10) || 0;
        var p = parseInt(v.price, 10) || 0;
        return cp > p;
      });

      if (!saleVars.length) {
        out.push(ensureCompareAtManual(o));
        continue;
      }

      var div = moneyDiv();
      saleVars.forEach(function (v) {
        out.push(buildCompareAtOfferFromVariant(o, prod, v, div));
      });
    }

    return out;
  }

  function fetchProductJs(handle) {
    if (!handle) return Promise.resolve(null);
    var url = '/products/' + encodeURIComponent(handle) + '.js';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function variantImageFromProduct(prod, variantId) {
    if (!prod || !variantId) return '';
    var vid = gidId(variantId);
    var variant = null;
    var variants = prod.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(vid)) {
        variant = variants[i];
        break;
      }
    }
    if (!variant) return '';

    var fi = variant.featured_image;
    if (fi) {
      if (typeof fi === 'string' && fi) return fi;
      if (fi.src) return fi.src;
    }

    var imageId = variant.image_id;
    var images = prod.images || [];
    for (var j = 0; j < images.length; j++) {
      var img = images[j];
      if (!img) continue;
      if (imageId && String(img.id) === String(imageId)) {
        return typeof img === 'string' ? img : (img.src || '');
      }
      var vIds = img.variant_ids || [];
      for (var k = 0; k < vIds.length; k++) {
        if (String(vIds[k]) === String(vid)) {
          return typeof img === 'string' ? img : (img.src || '');
        }
      }
    }
    return '';
  }

  function compareAtDealImage(offer, prod) {
    var items = configItems(offer.bundleItemsConfig);
    var manual = offer._manual || items[0] || {};
    var vid = manual.selectedVariantId || variantIdFromOffer(offer);
    var fromProd = variantImageFromProduct(prod, vid);
    if (fromProd) return fromProd;
    if (manual.image) return manual.image;
    var offerImgs = jp(offer.images);
    return offerImgs[0] || '';
  }

  /** Fast theme offer page (instant) — fallback app proxy for shared links */
  function offerFastPagePath() {
    var c = window.MMOffersConfig || {};
    if (c.offerPagePath === false || c.offerPagePath === '') return '';
    return c.offerPagePath || '/pages/offer';
  }

  function productPageUrlFromOffer(offer, ref, handleHint) {
    var h = handleHint || firstOfferHandle(offer);
    if (!h) return '';
    var root = cartRoot();
    var url = root + '/products/' + encodeURIComponent(h) + '?mm_ref=' + encodeURIComponent(ref || 'home');
    var vid = variantIdFromOffer(offer);
    if (vid) url += '&variant=' + encodeURIComponent(vid);
    return url;
  }

  function offerNavUrl(offer, ref, handleHint) {
    var root = cartRoot();
    ref = ref || 'home';

    if (offer && isCompareAtDeal(offer)) {
      var directProduct = productPageUrlFromOffer(offer, ref, handleHint);
      if (directProduct) return directProduct;
    }

    var slug = (offer && offer.slug) || '';
    if (!slug && offer && offer.id && String(offer.id).indexOf('global-') !== 0) {
      slug = offer.id;
    }
    var fastPath = offerFastPagePath();
    if (slug && fastPath) {
      return root + fastPath + '?slug=' + encodeURIComponent(slug) + '&mm_ref=' + encodeURIComponent(ref);
    }
    if (slug) {
      return root + '/apps/mm-app/offers/' + encodeURIComponent(slug) + '?mm_ref=' + encodeURIComponent(ref);
    }
    var productUrl = productPageUrlFromOffer(offer, ref, handleHint);
    if (productUrl) return productUrl;
    return root + '/apps/mm-app/offers/?mm_ref=' + encodeURIComponent(ref);
  }

  function offersSnapshot() {
    if (window.__mmPrefetch && typeof window.__mmPrefetch.readOffersSnapshot === 'function') {
      var snap = window.__mmPrefetch.readOffersSnapshot();
      if (snap && snap._ok) return snap;
    }
    if (window.__mmOffersBootstrap && Array.isArray(window.__mmOffersBootstrap.offers)) {
      return {
        offers: window.__mmOffersBootstrap.offers,
        settings: window.__mmOffersBootstrap.settings || {},
        _ok: true
      };
    }
    if (window.__mmPrefetch && window.__mmPrefetch.cache && window.__mmPrefetch.cache.offers && window.__mmPrefetch.cache.offers._ok) {
      return window.__mmPrefetch.cache.offers;
    }
    return null;
  }

  /** Fast offers list — prefer warm cache, short race (no multi-second spin). */
  function loadOffersList(opts) {
    opts = opts || {};
    var maxWait = opts.maxWait || 1200;

    function empty() {
      return { offers: [], settings: {} };
    }

    function direct() {
      if (window.__mmPrefetch && typeof window.__mmPrefetch.fetchOffers === 'function') {
        return window.__mmPrefetch.fetchOffers().then(function (d) {
          return d && Array.isArray(d.offers) ? d : empty();
        });
      }
      return fetch(offersApiUrl(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : empty(); })
        .catch(function () { return empty(); });
    }

    var snap = offersSnapshot();
    if (snap) return Promise.resolve(snap);

    var preload = window.__mmOffersPreload
      ? window.__mmOffersPreload.then(function (d) {
          if (d && Array.isArray(d.offers)) return d;
          throw new Error('preload invalid');
        })
      : Promise.reject(new Error('no preload'));

    return Promise.race([
      preload,
      direct(),
      new Promise(function (_, reject) {
        setTimeout(function () { reject(new Error('timeout')); }, maxWait);
      })
    ]).catch(function () {
      return direct();
    });
  }

  /** Instant snapshot for first paint (≤ maxMs). */
  function quickOffersList(maxMs) {
    maxMs = maxMs || 500;
    var snap = offersSnapshot();
    if (snap) return Promise.resolve(snap);

    var preload = window.__mmOffersPreload
      ? window.__mmOffersPreload.then(function (d) {
          return d && Array.isArray(d.offers) ? d : null;
        })
      : Promise.resolve(null);
    return Promise.race([
      preload,
      new Promise(function (resolve) {
        setTimeout(function () { resolve(null); }, maxMs);
      })
    ]).then(function (d) {
      return d || emptyOffers();
    });
  }

  function emptyOffers() {
    return { offers: [], settings: {} };
  }

  var prefetchedOfferUrls = {};

  function prefetchOfferUrl(url, opts) {
    if (!url || prefetchedOfferUrls[url]) return;
    prefetchedOfferUrls[url] = 1;
    opts = opts || {};
    try {
      var link = document.createElement('link');
      link.rel = opts.prerender ? 'prerender' : 'prefetch';
      link.href = url;
      if (!opts.prerender) link.as = 'document';
      document.head.appendChild(link);
    } catch (e) {}
    try {
      fetch(url, { credentials: 'same-origin', mode: 'cors', priority: opts.high ? 'high' : 'auto' }).catch(function () {});
    } catch (e2) {}
  }

  function warmOfferUrls(urls, opts) {
    if (!urls || !urls.length) return;
    opts = opts || {};
    var prerenderCount = opts.prerenderCount == null ? 2 : opts.prerenderCount;
    for (var i = 0; i < urls.length; i++) {
      if (!urls[i]) continue;
      prefetchOfferUrl(urls[i], { prerender: i < prerenderCount, high: i === 0 });
    }
  }

  /** Prevent carousel horizontal drag from blocking offer link taps. */
  function wireOfferCarouselClicks() {
    var tracks = document.querySelectorAll(
      '.mmh-carousel, .mmh-carousel--offers, .mm-cs-offers__track, .mmo-bundles-feed__list'
    );
    tracks.forEach(function (track) {
      if (track.dataset.mmOfferScrollWired === '1') return;
      track.dataset.mmOfferScrollWired = '1';
      var sx = 0;
      var sy = 0;
      var moved = false;
      track.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || !e.touches.length) return;
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          moved = false;
          track.dataset.mmCarouselMoved = '0';
        },
        { passive: true }
      );
      track.addEventListener(
        'touchmove',
        function (e) {
          if (!e.touches || !e.touches.length) return;
          if (Math.abs(e.touches[0].clientX - sx) > 22 || Math.abs(e.touches[0].clientY - sy) > 22) {
            moved = true;
            track.dataset.mmCarouselMoved = '1';
          }
        },
        { passive: true }
      );
      track.addEventListener(
        'click',
        function (e) {
          var a = targetClosest(e, 'a[href]');
          if (!a || !track.contains(a)) return;
          if (moved || track.dataset.mmCarouselMoved === '1') {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
            track.dataset.mmCarouselMoved = '0';
          }
        },
        true
      );
    });
  }

  function wireOfferNavigation() {
    if (document.documentElement.dataset.mmOfferNavWired === '1') return;
    document.documentElement.dataset.mmOfferNavWired = '1';

    document.addEventListener(
      'touchstart',
      function (e) {
        var a = targetClosest(e, 'a[href*="/apps/mm-app/offers/"], a[href*="/pages/bundles"], a[href*="/pages/offer"]');
        if (!a || !a.href) return;
        prefetchOfferUrl(a.href, { high: true });
      },
      { passive: true }
    );

    document.addEventListener(
      'pointerdown',
      function (e) {
        var a = targetClosest(e, 'a[href*="/apps/mm-app/offers/"], a[href*="/pages/bundles"], a[href*="/pages/offer"]');
        if (!a || !a.href) return;
        prefetchOfferUrl(a.href, { high: true });
      },
      { passive: true }
    );

    document.addEventListener(
      'mouseenter',
      function (e) {
        var a = targetClosest(e, 'a[href*="/pages/bundles"], a[href*="/pages/offer"], a[href*="/apps/mm-app/offers/"]');
        if (!a || !a.href) return;
        prefetchOfferUrl(a.href, { high: true });
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var a = targetClosest(e, 'a[href*="/apps/mm-app/offers/"], a[href*="/pages/bundles"], a[href*="/pages/offer"]');
        if (!a || !a.href) return;
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (a.target === '_blank') return;
        if (a.closest('[data-mm-carousel-moved="1"]')) return;
        prefetchOfferUrl(a.href);
      },
      true
    );

    wireOfferCarouselClicks();
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        wireOfferCarouselClicks();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireOfferNavigation);
  } else {
    wireOfferNavigation();
  }

  function isGiftCartLine(item) {
    if (!item) return false;
    var p = item.properties || {};
    return p._gift === 'true';
  }

  /** App offer line (bundle / BOGO / volume) — not tier gifts. */
  function isOfferCartLine(item) {
    if (!item || isGiftCartLine(item)) return false;
    var p = item.properties || {};
    if (p._offerType === 'CART_TIER_GIFT' || p.mm_offer_type === 'CART_TIER_GIFT') return false;
    return !!(p._offerId || p._offerType);
  }

  function runCartOp(fn) {
    if (window.MMCart && typeof window.MMCart.runCartMutation === 'function') {
      return window.MMCart.runCartMutation(fn);
    }
    return Promise.resolve().then(fn);
  }

  function fetchCartJson() {
    return fetch(cartRoot() + '/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  /** Extra units at full price — separate line without offer properties. */
  function increasePlainVariantQty(variantId, delta, opts) {
    delta = Math.max(1, parseInt(delta, 10) || 1);
    opts = opts || {};
    var vid = String(variantId == null ? '' : variantId);

    return runCartOp(function () {
      return fetchCartJson().then(function (cart) {
        var plain = (cart.items || []).find(function (it) {
          return String(it.variant_id) === vid && !isOfferCartLine(it) && !isGiftCartLine(it);
        });
        if (plain) {
          return fetch(cartRoot() + '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: plain.key, quantity: (plain.quantity || 0) + delta }),
          }).then(function (r) {
            return r.json();
          });
        }
        return fetch(cartRoot() + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10) || vid, quantity: delta }),
        }).then(function (r) {
          if (!r.ok) throw new Error('cart add failed');
          return fetchCartJson();
        });
      });
    }).then(function (cart) {
      if (opts.apply !== false) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        if (window.MMCart && typeof window.MMCart.applyUpdate === 'function') {
          window.MMCart.applyUpdate(cart, { loadRecs: false });
        } else if (window.MMCartPage && typeof window.MMCartPage.applyUpdate === 'function') {
          window.MMCartPage.applyUpdate(cart, { reloadSection: true });
        }
      }
      return cart;
    });
  }

  function normDealVid(raw) {
    return String(raw == null ? '' : raw).split('/').pop() || '';
  }

  /**
   * Merge incoming offer deals into cart `_flash_deals_data`.
   * Bundles stack `quantity` for the same offerId+variant so a 2nd claim stays discounted.
   * BOGO/volume keep one metadata row (set size / tier threshold); the Function uses cart qty.
   */
  function mergeOfferDeals(existing, incoming, offerId) {
    var offerKey = String(offerId == null ? '' : offerId);
    var prev = Array.isArray(existing) ? existing.slice() : [];
    var add = Array.isArray(incoming) ? incoming : [];
    if (!add.length) return prev;

    var out = prev.filter(function (d) {
      return String(d && d.offerId != null ? d.offerId : '') !== offerKey;
    });
    var mine = prev
      .filter(function (d) {
        return String(d && d.offerId != null ? d.offerId : '') === offerKey;
      })
      .map(function (d) {
        return Object.assign({}, d);
      });

    add.forEach(function (inc) {
      var row = Object.assign({}, inc, {
        offerId: offerKey || String(inc.offerId || ''),
      });
      var iVid = normDealVid(row.variantId);
      var iType = String(row.type || '');
      var idx = -1;
      for (var i = 0; i < mine.length; i++) {
        if (normDealVid(mine[i].variantId) === iVid && String(mine[i].type || '') === iType) {
          idx = i;
          break;
        }
      }

      if (idx >= 0 && iType === 'bundle') {
        var cur = mine[idx];
        var q0 = parseInt(cur.quantity, 10);
        var q1 = parseInt(row.quantity, 10);
        if (!isFinite(q0) || q0 < 0) q0 = 0;
        if (!isFinite(q1) || q1 < 1) q1 = 1;
        cur.quantity = q0 + q1;
        if (row.discountPercent != null) cur.discountPercent = row.discountPercent;
        return;
      }

      if (idx >= 0) {
        var prevRow = mine[idx];
        var prevVol = prevRow.volumeQty;
        Object.assign(prevRow, row);
        if (iType === 'volume') {
          var v0 = parseInt(prevVol, 10);
          var v1 = parseInt(row.volumeQty, 10);
          if (isFinite(v0) && v0 > 0 && isFinite(v1) && v1 > 0) {
            prevRow.volumeQty = Math.min(v0, v1);
          }
        }
        return;
      }

      mine.push(row);
    });

    return out.concat(mine);
  }

  /** Increase an offer cart line and sync bundle qty allowance in `_flash_deals_data`. */
  function increaseOfferLineQty(lineItem, delta, opts) {
    delta = Math.max(1, parseInt(delta, 10) || 1);
    opts = opts || {};
    if (!lineItem || !lineItem.key) {
      return increasePlainVariantQty(lineItem && lineItem.variant_id, delta, opts);
    }
    var key = lineItem.key;
    var vid = normDealVid(lineItem.variant_id);
    var props = lineItem.properties || {};
    var offerId = props._offerId != null ? String(props._offerId) : '';
    var offerType = String(props._offerType || '').toUpperCase();

    return runCartOp(function () {
      return fetchCartJson().then(function (cart) {
        var line = (cart.items || []).find(function (it) {
          return it.key === key;
        });
        if (!line) throw new Error('offer line missing');
        return fetch(cartRoot() + '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: (line.quantity || 0) + delta }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart2) {
            if (!(offerType === 'BUNDLE' || offerType === 'PACKAGE_BUILDER') || !offerId) {
              return cart2;
            }
            var deals = [];
            try {
              deals = JSON.parse((cart2.attributes && cart2.attributes._flash_deals_data) || '[]');
            } catch (e) {
              deals = [];
            }
            var changed = false;
            deals.forEach(function (d) {
              if (String(d.offerId) !== offerId) return;
              if (String(d.type || '') !== 'bundle') return;
              if (normDealVid(d.variantId) !== vid) return;
              var q = parseInt(d.quantity, 10);
              if (!isFinite(q) || q < 0) q = 0;
              d.quantity = q + delta;
              changed = true;
            });
            if (!changed) return cart2;
            return fetch(cartRoot() + '/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { _flash_deals_data: JSON.stringify(deals) },
              }),
            }).then(function () {
              return fetchCartJson();
            });
          });
      });
    }).then(function (cart) {
      if (opts.apply !== false) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        if (window.MMCart && typeof window.MMCart.applyUpdate === 'function') {
          window.MMCart.applyUpdate(cart, { loadRecs: false });
        } else if (window.MMCartPage && typeof window.MMCartPage.applyUpdate === 'function') {
          window.MMCartPage.applyUpdate(cart, { reloadSection: true });
        }
      }
      return cart;
    });
  }

  /** Open MM cart sheet after offer ATC — no full-page redirect. */
  function openCartSheet(cart) {
    function apply(c) {
      if (!c) return false;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
      var mc = window.MMCart;
      if (!mc) return false;
      if (typeof mc.updateBadges === 'function') mc.updateBadges(c.item_count, true);
      if (typeof mc.open === 'function') {
        mc.open({ skipRefresh: true, cart: c });
        return true;
      }
      if (typeof mc.refresh === 'function') {
        mc.refresh().then(function (fresh) {
          if (typeof mc.open === 'function') mc.open({ skipRefresh: true, cart: fresh });
        });
        return true;
      }
      return false;
    }

    function waitApply(c, start) {
      if (apply(c)) return Promise.resolve(c);
      if (Date.now() - start > 8000) {
        return Promise.resolve(c);
      }
      return new Promise(function (resolve) {
        setTimeout(function () { waitApply(c, start).then(resolve); }, 60);
      });
    }

    if (cart && cart.items !== undefined) {
      return waitApply(cart, Date.now());
    }
    if (window.MMCart && typeof window.MMCart.refresh === 'function') {
      return window.MMCart.refresh().then(function (c) { return waitApply(c, Date.now()); });
    }
    return fetch(cartRoot() + '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return waitApply(c, Date.now()); });
  }

  function ensureCartCountryAttribute(cart) {
    var country = marketCountry();
    if (!country) return Promise.resolve(cart || null);
    var attrs = (cart && cart.attributes) || {};
    if (String(attrs._mm_country || '').toUpperCase() === country) {
      return Promise.resolve(cart);
    }
    var key = 'mm_cart_country_set_' + country;
    try {
      if (!cart && sessionStorage.getItem(key) === '1') return Promise.resolve(null);
    } catch (e) {}
    return Promise.resolve(cart || fetchCartJson()).then(function (c) {
      var current = c && c.attributes ? String(c.attributes._mm_country || '').toUpperCase() : '';
      if (current === country) return c;
      return fetch(cartRoot() + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { _mm_country: country } }),
      }).then(function (r) {
        if (!r.ok) throw new Error('country attribute update failed');
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        return r.json();
      });
    }).catch(function () {
      return cart || null;
    });
  }

  window.MMOffers = {
    localeCode: localeCode,
    isAr: isAr,
    t: t,
    moneyDiv: moneyDiv,
    marketCountry: marketCountry,
    ensureCartCountryAttribute: ensureCartCountryAttribute,
    offersApiUrl: offersApiUrl,
    fmtPrice: fmtPrice,
    priceSpan: priceSpan,
    jp: jp,
    configItems: configItems,
    offerTitle: offerTitle,
    volumeUnitLabels: volumeUnitLabels,
    volumeQtyLabel: volumeQtyLabel,
    typeLabel: typeLabel,
    stockLabel: stockLabel,
    startTimer: startTimer,
    offerPrices: offerPrices,
    estimateBundlePrices: estimateBundlePrices,
    estimateBogoPrices: estimateBogoPrices,
    estimateVolumePrices: estimateVolumePrices,
    volumeMaxPct: volumeMaxPct,
    bogoLabel: bogoLabel,
    openCartSheet: openCartSheet,
    isOfferCartLine: isOfferCartLine,
    isGiftCartLine: isGiftCartLine,
    increasePlainVariantQty: increasePlainVariantQty,
    increaseOfferLineQty: increaseOfferLineQty,
    mergeOfferDeals: mergeOfferDeals,
    loadOffersList: loadOffersList,
    quickOffersList: quickOffersList,
    offersSnapshot: offersSnapshot,
    offerNavUrl: offerNavUrl,
    productPageUrlFromOffer: productPageUrlFromOffer,
    firstOfferHandle: firstOfferHandle,
    variantIdFromOffer: variantIdFromOffer,
    variantLabelFromOffer: variantLabelFromOffer,
    manualImageFromOffer: manualImageFromOffer,
    isCompareAtDeal: isCompareAtDeal,
    isPerVariantCompareAtDeal: isPerVariantCompareAtDeal,
    expandCompareAtOffers: expandCompareAtOffers,
    fetchProductJs: fetchProductJs,
    ensureCompareAtManual: ensureCompareAtManual,
    variantImageFromProduct: variantImageFromProduct,
    compareAtDealImage: compareAtDealImage,
    prefetchOfferUrl: prefetchOfferUrl,
    warmOfferUrls: warmOfferUrls,
    wireOfferNavigation: wireOfferNavigation,
    hydratePrices: function (root) {
      var scope = root || document;
      if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.formatWithTax === 'function') {
        scope.querySelectorAll('.mm-taxed-price[data-original-price]').forEach(function (el) {
          var n = parseInt(el.getAttribute('data-original-price'), 10);
          if (isNaN(n)) return;
          var elDiv = el.getAttribute('data-mm-divisor');
          var div = elDiv ? parseInt(elDiv, 10) : moneyDiv(el.closest('[data-money-divisor]') || el);
          if (div !== 100 && div !== 1000) div = moneyDiv(el.closest('[data-mm-bundles-feed]') || el);
          el.textContent = window.mmCurrencyConfig.formatWithTax(n, div);
        });
      }
      if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.refreshPrices === 'function') {
        window.mmCurrencyConfig.refreshPrices();
      }
    },
    shopRoot: function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.endsWith('/') ? root.slice(0, -1) : root;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureCartCountryAttribute(); });
  } else {
    ensureCartCountryAttribute();
  }
})();
